{
  "authorization_in_progress": "Anmeldung läuft ...",
  "will_redirect_to": "Automatische Umleitung zu",
  "login": {
    "identifying_organization": "Identifiziere Organisation..."
  },
  "go_back": "Zurück",
  "pairing": {
    "title": "Endgerät Verknüpfen",
    "instructions": "Um Ihr Endgerät zu verknüpfen, starten sie bitte die Client-Anwendung auf ihrem Endgerät und geben sie den dort angezeigten Code hier ein.",
    "client_hint": "Bevor Sie ihr Endgerät verknüpfen können, stellen Sie bitte sicher, dass sie die Client-Anwendung heruntergeladen und installiert haben.",
    "install_client": "Client App installieren",
    "failure": "Die Verbindung ist fehlgeschlagen, der von Ihnen eingegebene Kopplungs-Code ({{code}}) ist möglicherweise falsch oder abgelaufen."
  },
  "clients": {
    "go_to_overview": "Andere Client-Anwendung installieren",
    "coming_soon": "Auf Anfrage verfügbar",
    "connected": "Verbunden",
    "connected_clients": "Verknüpfte Endgeräte",
    "active": "Aktiv",
    "set_active": "Auswählen",
    "title": "Client Anwendung installieren",
    "instructions": "Um den vollen Funktionsumfang nutzen zu können, laden sie bitte die Client-Anwendung herunter und installieren Sie sie auf ihrem Endgerät. Die folgenden Plattformen werden unterstützt:",
    "download_for_quest": "Meta",
    "download_for_focus": "VIVE",
    "download_for_pico": "PICO",
    "download_for_windows": "Windows",
    "connect_hint": "Nach der erfolgreichen Installation der Client-Anwendung fahren Sie bitte mit der Verknpüfung ihres Headsets fort.",
    "connect": "Endgerät verknüpfen",
    "installation_title": "{{device}} Client Installation",
    "device": {
      "wave": "VIVE",
      "meta": "Meta Quest",
      "pico": "PICO",
      "desktop": "Windows",
      "apple_vision_pro": "Apple Vision Pro",
      "magic_leap": "Magic Leap"
    },
    "installation_methods": {
      "sideloading": {
        "title": "Installation per Sideloading",
        "requirements": "Für die Installation der Client-Anwendung per Sideloading muss auf Ihrem {{device}} Gerät der Entwicklermodus aktiviert sein.",
        "download_first": "Um die Anwendung per Sideloading zu installieren, laden Sie bitte zunächst die <1>Binärdatei (apk)</1> der Anwendung über die folgende Schaltfläche herunter:",
        "download": "APK herunterladen",
        "method_intro": "Nachdem Sie obenstehende apk erfolgreich heruntergeladen haben, folgen Sie bitte den Anweisungen, um die Client-Anwendung auf ihrem {{device}} per Sideloading zu installieren:",
        "recommended": "empfohlen",
        "official_guide": "Official Guide"
      },
      "meta_applab": {
        "title": "Meta Store",
        "cta": "Meta Store öffnen",
        "text": "Um die Client-Anwendung für Ihr Quest-Gerät über Meta Store zu installieren, klicken Sie einfach auf die folgende Schaltfläche und befolgen Sie die dortigen Anweisungen:"
      },
      "vive_business_appstore": {
        "title": "VIVE Business AppStore",
        "cta": "VIVE Business AppStore öffnen",
        "text": "Um die Client-Anwendung für Ihr VIVE-Gerät über den VIVE Business App Store zu installieren, klicken Sie einfach auf die folgende Schaltfläche und befolgen Sie die dortigen Anweisungen:"
      },
      "pico_enterprise_store": {
        "title": "Pico Enterprise Store",
        "text": "Um die Client-Anwendung für Ihr PICO Enterprise-Gerät zu installieren, öffnen Sie bitte den Store auf Ihrem PICO Enterprise-Gerät und suchen Sie nach „Innoactive Portal“."
      },
      "recommended": "Empfohlen",
      "mdm": {
        "copy_download_url": "Klicken Sie hier, um die URL der APK der Client-Anwendung zu kopieren",
        "intro": "Um die Clientanwendung für {{device}} über ein Mobile Device Management (MDM)-System zu verteilen, befolgen Sie bitte die nachstehende Anleitung.",
        "steps": {
          "add_application": {
            "text": "Suchen Sie nach einer Option zum „Hinzufügen“, „Hochladen“ oder „Bereitstellen“ einer neuen Anwendung. \nDies kann Optionen zum direkten Hochladen einer APK oder zum Verknüpfen mit einer externen APK umfassen. \nSie können die folgende URL verwenden, um entweder das APK herunterzuladen und in das MDM-System hochzuladen oder es zur externen Verlinkung des APK zu verwenden:",
            "title": "Fügen Sie die Anwendung hinzu"
          },
          "choose_deployment_method": {
            "options": {
              "direct_upload": {
                "text": "Wählen Sie „Hochladen“ und wählen Sie die APK-Datei von Ihrem Computer aus, um sie direkt in das MDM-System hochzuladen.",
                "title": "Direkter Upload"
              },
              "external_link": {
                "text": "Wählen Sie „Nach URL hinzufügen“ oder „Externe Anwendung verknüpfen“ und geben Sie die URL an, unter der das APK gehostet wird.",
                "title": "externer Link"
              }
            },
            "text": "Abhängig von Ihrer MDM-Plattform stehen Ihnen möglicherweise unterschiedliche Optionen zum Hinzufügen der Anwendung zur Verfügung.",
            "title": "Wählen Sie die Bereitstellungsmethode"
          },
          "configure_app_settings": {
            "text": "Geben Sie die erforderlichen Details zur Anwendung ein, z. B. Name, Beschreibung, Version und alle anderen für Ihre MDM-Plattform erforderlichen Metadaten.",
            "text2": "Definieren Sie Bereitstellungseinstellungen, z. B. für welche Benutzer oder Gruppen die App verfügbar sein soll, und etwaigen bedingten Zugriff basierend auf der Gerätekonformität.",
            "title": "App-Einstellungen konfigurieren"
          },
          "deploy_the_application": {
            "text": "Ordnen Sie die App bestimmten Gruppen oder Benutzern zu. \nKlicken Sie je nach Ihrer Wahl auf „Veröffentlichen“, „Bereitstellen“ oder eine ähnliche Option, um die Anwendung über das MDM verfügbar zu machen.",
            "title": "Stellen Sie die Anwendung bereit"
          },
          "login": {
            "text": "Greifen Sie mit Ihren Anmeldeinformationen auf die Verwaltungskonsole Ihrer MDM-Plattform zu. \nDies kann normalerweise über einen Webbrowser erfolgen.",
            "title": "Melden Sie sich bei der MDM-Administratorkonsole an"
          },
          "manage_updates_and_support": {
            "text": "Suchen Sie regelmäßig nach neuen Versionen der Anwendung und wiederholen Sie den Upload oder aktualisieren Sie den externen Link bei Bedarf.",
            "text2": "Bieten Sie fortlaufenden Support für Endbenutzer und sorgen Sie für eine klare Kommunikation über Anwendungsaktualisierungen und neue Funktionen.",
            "title": "Verwalten Sie Updates und Support"
          },
          "navigate_to_app_management": {
            "text": "Gehen Sie in der MDM-Konsole zu dem Abschnitt, in dem Sie Anwendungen verwalten können, die oft als „Apps“, „Anwendungen“ oder „App-Katalog“ bezeichnet werden.",
            "title": "Navigieren Sie zu App-Verwaltung"
          },
          "set_permissions_and_policies": {
            "text": "Konfigurieren Sie appspezifische Berechtigungen, die für die Funktionalität erforderlich sind.",
            "text2": "Legen Sie Sicherheitsrichtlinien und Datenverarbeitungsregeln fest, die den Organisationsstandards entsprechen.",
            "title": "Legen Sie Berechtigungen und Richtlinien fest"
          },
          "verify_deployment": {
            "text": "Überwachen Sie den Bereitstellungsstatus über die MDM-Konsole, um sicherzustellen, dass die Anwendung erfolgreich verteilt und auf den Zielgeräten installiert wird.",
            "text2": "Suchen Sie nach Installationsfehlern und beheben Sie alle vom Benutzer gemeldeten Probleme.",
            "title": "Bereitstellung überprüfen"
          }
        },
        "title": "Mobiles Gerätemanagement (MDM)"
      },
      "intro": "Um die Clientanwendung für {{device}} zu installieren, wählen Sie bitte eine der folgenden Methoden:"
    },
    "desktop_client": {
      "download_cta": "Installationsprogramm herunterladen",
      "intro": "Um das Herunterladen und Ausführen von Anwendungen lokal zu unterstützen, laden Sie bitte zunächst das folgende Installationsprogramm für die Windows-Clientanwendung herunter:",
      "installation_instructions": "Nachdem Sie das Installationsprogramm heruntergeladen haben, folgen Sie bitte den Installationsanweisungen, um die Client-Anwendung auf Ihrem Windows-Computer zu installieren."
    },
    "download_for_apple_vision_pro": "Apple Vision Pro",
    "download_for_magic_leap": "Magic Leap 2"
  },
  "footer": {
    "terms": "Nutzungsbedingungen",
    "privacy": "Datenschutz",
    "legal": "Rechtliches",
    "version": "Version (Web): {{version}}",
    "powered_by": "Dieser Service wird von Innoactive zur Verfügung gestellt. <2>innoactive.io/portal</2>",
    "support": "Support"
  },
  "header": {
    "search": "Suchen",
    "language": "Sprache",
    "logout": "Abmelden",
    "security": "Sicherheit",
    "streaming": "Streaming"
  },
  "search": {
    "no_app": "Leider konnten keine passenden Anwendungen für den Suchbegriff \"{{term}}\" gefunden werden",
    "placeholder": "Nach Anwendungen suchen",
    "minimum_chars": "Bitte geben Sie mindestens 3 Zeichen ein, um eine Suche zu starten",
    "filter": {
      "label": "Filter",
      "rendering": {
        "title": "Rendering",
        "label": "Render Art: {{type}}",
        "all": "Alle Renderarten",
        "local": "Nur Lokal",
        "streaming": "Nur gestreamed"
      },
      "device": {
        "title": "Endgeräte",
        "label": "Endgerät: {{type}}",
        "all": "Alle Geräte",
        "win-non-vr": "Browser",
        "win-vr": "Windows XR",
        "quest": "Meta Quest",
        "wave": "HTC Vive",
        "pico": "PICO",
        "magic-leap": "Magic Leap"
      }
    }
  },
  "languages": {
    "en": "Englisch",
    "de": "Deutsch",
    "es": "Spanisch"
  },
  "details": {
    "unsupported": "Keine Aktion möglich",
    "launch_in_cloud": "Auf XR Headset streamen",
    "launch_browser": "Stream im Browser öffnen",
    "launch_on_standalone_device": "Auf XR Headset ausführen",
    "launch_locally": "Herunterladen und ausführen",
    "edit": "Editieren im Control Panel",
    "available_clients": "Verfügbare {{clients}}",
    "vr_clients": "XR Headsets",
    "generic_clients": "Geräte",
    "pair_vr_device": "Endgerät verbinden",
    "stream_to_device": "Auf {{name}} streamen",
    "launch_on_device": "Auf {{name}} starten",
    "not_installed_on_device": "Nicht auf {{name}} installiert",
    "install_on_device": "Auf {{name}} installieren & starten",
    "install_on_server": "Auf Streaming-Server installieren",
    "queue_for_installation": "Für Installation vormerken",
    "fast_launch_tooltip": "Schnellstart - App ist auf Server vorinstalliert",
    "installing": "Installation anfordern",
    "installed_addendum": " (Installiert)",
    "related_apps": "Verwandte Apps",
    "not_connected_title": "Keine Verbindung!",
    "not_connected_text": "Es besteht derzeit keine Verbindung zum Server. Bitte stellen Sie die Verbindung wieder her oder wenden Sie sich an einen Administrator.",
    "streaming_preferences": "Streaming Präferenzen",
    "download_apk": ".apk herunterladen",
    "download_exe": ".zip herunterladen",
    "download_windows_vr": "Windows VR-Build herunterladen (.zip)",
    "download_windows_non_vr": "Windows Non-VR-Build herunterladen (.zip)",
    "standalone_app_not_installed_title": "Anwendung nicht installiert",
    "standalone_app_not_installed": "Die Anwendung ist nicht auf ihrem Endgerät installiert. Bitte installieren Sie die Anwendung zunächst, um sie ausführen zu können.",
    "no_actions_available_title": "Keine Aktionen verfügbar",
    "no_actions_available": "Für diese Anwendung sind keine Aktionen verfügbar. Bitte verbinden Sie ein Endgerät und überprüfen Sie die Konfiguration der Anwendung.",
    "changelog": "Änderungsprotokoll",
    "no_changelog_available": "Kein Änderungsprotokoll bereitgestellt",
    "not_installed_addendum": " (Nicht installiert)",
    "connecting_title": "Verbinden ...",
    "connecting_text": "Es wird versucht, eine Verbindung zum Dienst (wieder) herzustellen...",
    "changelog_show_more": "Mehr anzeigen ...",
    "stream_preferences_wizard": "Assistent für Server-Standort",
    "switch_version": "Versionsversion",
    "device_incompatible_tooltip": "Das ausgewählte Gerät unterstützt kein verschlüsseltes Streaming.",
    "disconnected_tooltip": "Keine Verbindung zum Dienst.",
    "download_windows": "Build für <2>{{platforms}}</2> herunterladen"
  },
  "request_access": {
    "request_access": "Zugriff beantragen",
    "access_requested": "Zugriff beantragt ({{relativeDate}}).",
    "message_label": "Bitte teilen Sie uns mit, warum Sie Zugriff benötigen ...",
    "cancel": "Abbrechen",
    "submit": "Senden",
    "pending_request": "Sie haben bereits Zugriff beantragt. Ihre Nachricht: ",
    "handled_externally": "Bitte gehen Sie zu <2>{{url}}</2>, um Zugriff auf diese Anwendung zu beantragen."
  },
  "launch": {
    "launch_app": "Anwendung starten",
    "launch_app_with_name": "<strong>\"{{name}}\"</strong> starten",
    "custom_protocol_prompt_instruction": "Bitte klicken Sie auf <strong>\"Portal Desktop Client öffnen\"</strong> im oben angezeigten Dialog.",
    "custom_protocol_prompt_reopen": "Wenn Sie keinen Dialog in ihrem Browser sehen, stellen Sie sicher, dass Portal Desktop Client installiert ist\nund klicken Sie bitte auf <strong>\"{{action}}\"</strong>.",
    "custom_protocol_prompt_reopen_action": "{{name}} starten",
    "desktop_client_not_installed_question": "Haben Sie den Portal Desktop Client installiert?",
    "download_now": "Jetzt herunterladen",
    "check_desktop_client_installation": "Warte auf Desktop Client",
    "app_not_found_title": "Anwendungsinformationen können nicht geladen werden.",
    "app_not_found": "Dies kann an unzureichenden Berechtigungen liegen oder die Anwendung ist möglicherweise nicht vorhanden. \nBitte überprüfen Sie Ihre Zugriffsrechte oder wenden Sie sich an den Support, um Hilfe zu erhalten.",
    "region_incompatible": "Region inkompatibel",
    "region_incompatible_detail": "Unsere Systeme haben festgestellt, dass die gewünschte Region „{{ preferredRegion }}“ entweder kein Streaming für die ausgewählte Anwendung unterstützt oder dass nicht sichergestellt werden kann, dass die Region von Ihrem Gerät aus erreichbar ist. Wir empfehlen daher stattdessen die Region „{{ bestRegion }}“ zu verwenden.",
    "region_incompatible_force_continue": "Wenn Sie „{{ preferredRegion }}“ dennoch verwenden wollen, können Sie <2>hier klicken, um diese Warnung ignorieren</2> und - auf das Risiko einer eingeschränkten Erfahrung hin - fortzufahren.",
    "region_no_capacity": "Region nicht verfügbar",
    "region_no_capacity_detail": "Ihre gewählte Region „{{ preferredRegion }}“ kann derzeit aufgrund von Ressourcenknappheit nicht für Streaming genutzt werden.",
    "force_continue": "In {{ regionName }} fortfahren",
    "no_region_available": "Kein Streaming-Server verfügbar",
    "no_region_available_detail": "Für die ausgewählte Anwendung ist kein kompatibler Streaming-Standort vorhanden. \nBitte wenden Sie sich an den Administrator Ihrer Organisation.",
    "back": "Zurück",
    "cancel": "Abbrechen",
    "continue": "{{ regionName }} nutzen",
    "launch_type_unsupported": "Nicht unterstützter Sitzungstyp!",
    "region_no_capacity_redirect_detail": "Ihre gewählte Region {{ preferredRegion }} kann derzeit aufgrund von Ressourcenknappheit nicht für Streaming genutzt werden. Wir haben Ihre Sitzung automatisch so umgeleitet, dass sie stattdessen in {{ alternativeRegion }} ausgeführt wird.",
    "region_no_capacity_alternative": "Sie können es entweder zu einem späteren Zeitpunkt noch einmal versuchen oder stattdessen z.B. die Region {{ alternativeRegion }} verwenden.",
    "region_no_capacity_loading": "Bitte haben Sie etwas Geduld, während wir nach alternativen Regionen zum Rendern suchen ...",
    "unknown_region": "Unbekannte Region",
    "select_target_device": "Bitte wählen Sie aus, welches Ihrer verbundenen Geräte zum Ausführen der Sitzung verwendet werden soll:",
    "select_vm_size": "Bitte wählen Sie die Leistungsstufe aus, die Sie verwenden möchten, um die Anwendung in {{ regionName }} zu starten:",
    "force_continue_with_vm_size": "{{ regionName }} ({{ vmSize }}) verwenden",
    "region_requires_vm_size_change": "Zusätzliche Konfiguration für Region erforderlich",
    "back_to_recommendation": "Zurück zur Empfehlung",
    "vm_size_too_small": "Die ausgewählte Leistungsstufe ({{ selectedVmSize }}) ist niedriger als die Anforderung für die Anwendung ({{ targetVmSize }}). Bitte beachten Sie, dass das Ignorieren dieser Tatsache zu Leistungseinbußen führen kann.",
    "no_app_build_for_launch": "Für den angeforderten Start wurde kein kompatibler Anwendungsbuild gefunden.",
    "application_not_installed_on_device": "Die Anwendung ist nicht auf dem Gerät installiert. \nBitte installieren Sie es zuerst!",
    "no_matching_launch_configuration": "Es konnte nicht ermittelt werden, wie die ausgewählte Anwendung gestartet werden soll",
    "select_launch_configuration": "Bitte wählen Sie aus, wie die Anwendung gestartet werden soll",
    "potentially_uninstalled_desktop_client": "Es sieht so aus, als ob Sie den Portal Desktop Client noch nicht installiert haben. Bitte stellen Sie sicher, dass er zuerst auf Ihrem Windows-PC installiert ist.",
    "potentially_uninstalled_desktop_client_dialog_close": "Schließen",
    "potentially_uninstalled_desktop_client_title": "Portal Desktop Client nicht installiert?",
    "go_to_desktop_client_installation_instructions": "Installationsanleitung anzeigen",
    "desktop_client_unsupported_platform": "Das lokale Starten dieser Anwendung wird auf Ihrem Gerät nicht unterstützt. \nBitte wechseln Sie zu einem Windows-PC, um diese Anwendung lokal zu starten, oder verwenden Sie eine andere Möglichkeit, die Anwendung zu starten.",
    "show_alternative_launch_modes": "App anders starten",
    "device_incompatible": "Gerät nicht kompatibel",
    "device_not_supporting_encrypted_vr_streaming_error": "Das von Ihnen ausgewählte Gerät unterstützt verschlüsseltes VR-Streaming nicht. \nBitte stellen Sie sicher, dass Sie auf dem Gerät die erforderliche Berechtigung erteilt haben, um verschlüsseltes VR-Streaming zu ermöglichen.",
    "error_fetching_encryption_setting": "Fehlgeschlagenes Laden von Benutzerpräferenzen / Organisationsrichtlinien",
    "legacy": {
      "unsupported_launch_mode": "Nicht unterstützter Startmodus!"
    },
    "app_not_found_invalid_id": "Ungültige Anwendungs -ID.",
    "latency_test_required_info": "Identifizieren Sie den besten Serverstandort ...",
    "selected_region_incompatible_no_alternative": "Unsere Systeme haben festgestellt, dass Ihre gewünschte Region ({{ferredRegion }}) entweder kein Streaming für die ausgewählte Anwendung unterstützt oder wir nicht sicherstellen können, dass die Region von Ihrem Gerät aus erreichbar ist. \nDerzeit steht Ihnen kein alternativer Streaming-Server zur Verfügung. \nBitte wenden Sie sich an einen Administrator."
  },
  "notifications": {
    "title": "Hinweis zur Sitzung",
    "MaxSoftSessionRunTime": "Ihre Sitzung läuft bereits seit geraumer Zeit. Bitte beenden Sie sie, wenn Sie sie nicht mehr benötigen.",
    "MaxSessionRunTime": "Ihre Sitzung hat die maximale Laufzeit überschritten und wird automatisch beendet.",
    "HighLatency": "Warnung: hohe Latenz für aktuelle Sitzung in {{ region }} {{ latency }}ms. Die Qualität kann dadurch beeinträchtigt werden.",
    "SessionInactivityTimeoutTime": "Die Sitzung wurde beendet, weil das Gerät zu lange inaktiv war.",
    "HotVirtualMachineWithPreInstalledAppsUsed": "Diese Sitzung nutzte eine laufende reservierte Instanz mit vorinstallierten Apps.",
    "VirtualMachineDestroyedBecauseOfError": {
      "generic": "Die virtuelle Maschine konnte aufgrund eines technischen Fehlers nicht bereitgestellt werden. Bitte versuchen Sie es erneut.",
      "CloudProviderNoAvailability": "In der ausgewählten Cloud-Region sind keine virtuellen Maschinen verfügbar. Bitte wählen Sie eine andere Region oder versuchen Sie es später erneut.",
      "ImageNotFound": "Das erforderliche Image der virtuellen Maschine wurde nicht gefunden. Bitte wenden Sie sich an den Support.",
      "CouldNotProvision": "Ein Infrastruktur-Konfigurationsfehler ist aufgetreten. Bitte wenden Sie sich an den Support.",
      "title": "Infrastrukturfehler"
    }
  },
  "streaming_server_not_ready": {
    "title": "Streaming-Server wird vorbereitet",
    "description": "Ihr persönlicher Streaming-Server installiert noch Anwendungen. Dies kann einige Minuten dauern.",
    "wait_option": "Zurück und warten",
    "new_server_option": "Neuen Streaming-Server erhalten",
    "new_server_warning": "Ein neuer Server wird Ihren ausstehenden Server zerstören, um zusätzliche Kosten zu vermeiden."
  },
  "app": {
    "streaming_server_preparing": "Server wird vorbereitet",
    "streaming_server_details": "Streaming-Server Details",
    "streaming_server_status": "Status",
    "preparing": "Wird vorbereitet",
    "streaming_server_region": "Region",
    "streaming_server_size": "Größe",
    "streaming_server_apps": "Installierte Apps",
    "streaming_server_created": "Erstellt",
    "streaming_server_preparing_message": "Ihr Streaming-Server wird vorbereitet. Dies dauert normalerweise einige Minuten.",
    "schedule_session": "Sitzung planen"
  },
  "session": {
    "pairing": {
      "no_device_pico": "Um die Anwendung zu starten, stellen Sie bitte sicher, dass Ihr PICO Headset verbunden ist.",
      "no_device_quest": "Um die Anwendung zu starten, stellen Sie bitte sicher, dass Ihr Quest Headset verbunden ist.",
      "no_device_wave": "Um die Anwendung zu starten, stellen Sie bitte sicher, dass Ihr Vive Headset verbunden ist.",
      "connect_standalone_device": "Um die Anwendung zu starten, stellen Sie bitte sicher, dass ein unterstütztes XR Headset verbunden ist."
    },
    "end": "Sitzung beenden",
    "abort": "Abbrechen",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "idle": "Keine aktive Sitzung",
    "browse": "Durchsuchen Sie die verfügbaren Apps",
    "ready": "Sitzung ist bereit!",
    "ready_short": "Sitzung bereit!",
    "notification": "Bitte klicken Sie auf diese Benachrichtigung um zu ihrer Sitzung zu gelangen!",
    "ready_instructions": "Bitte fahren Sie mit \"{{ device }}\" fort.",
    "ready_instructions_xr": "Bitte setzen Sie Ihr \"{{ device }}\" auf, um fortzufahren.",
    "ready_instructions_desktop": "Bitte fahren Sie auf Ihrem Desktop fort.",
    "seconds": "Sek.",
    "seconds_plural": "Sek.",
    "minutes": "Min.",
    "minutes_plural": "Min.",
    "running": "Sitzung läuft!",
    "app_running": "\"{{name}}\" läuft auf {{ device }}.",
    "app_running_browser": "\"{{name}}\" läuft. Sie werden in Kürze verbunden...",
    "running_on": "Läuft auf: <strong>{{name}}</strong>",
    "networking_problems_title": "Netzwerk-Performance unzureichend",
    "networking_problems": "Während Ihrer Sitzung haben wir Probleme mit der Netzwerk-Performance auf ihrem Standalone XR Headset erkannt.",
    "networking_latency": "• Ihre Netzwerklatenz ist zu hoch",
    "networking_bandwidth": "• Ihre Internetgeschwindigkeit ist unzureichend",
    "networking_unstable": "• Ihre Internetverbindung ist instabil",
    "networking_help": "Für weitergehende Informationen, öffnen sie folgenden Link: ",
    "abort_dialog": {
      "title": "Sitzung beenden",
      "are_you_sure": "Sind Sie sicher, dass sie diese Sitzung beenden möchten?"
    },
    "session_already_running_dialog": {
      "title": "Laufende Sitzung erkannt",
      "body": "Wenn Sie unten bestätigen, wird Ihre bestehende Sitzung beendet und eine neue Sitzung gestartet, um die ausgewählte Anwendung auszuführen.\n\nKlicken Sie auf „Abbrechen“, um stattdessen zur aktiven Sitzung zu wechseln."
    },
    "application_requires_update_dialog": {
      "title": "Update vorhanden",
      "body": "Für diese App kann eine neue Version installiert werden, wollen Sie ein update durchführen?"
    },
    "session_error_dialog": {
      "title": "Es scheint ein Problem mit Ihrer Sitzung zu geben",
      "continue": "Ignorieren",
      "additional_info": "Bitte verwenden Sie diese Sitzungsnummer, um weitere Informationen vom Support zu erhalten:",
      "report": "Support",
      "report_summary_session": "Problem in Sitzung {{ sessionId }}",
      "report_summary_starting_session": "Problem beim Starten einer Sitzung",
      "report_description": "Problembeschreibung:\n\n{{ errorMessage }}.\n\nBitte machen Sie zusätzliche Angaben dazu, was vor dem Auftreten des Fehlers geschah.",
      "title_startup": "Beim Versuch, die Sitzung zu starten, ist ein Problem aufgetreten"
    },
    "unexpected_error": "Ein unerwarteter Fehler ist aufgetreten",
    "go_to_session": "Zur Sitzung",
    "ready_acknowledge": "OK",
    "active": "Sitzung läuft",
    "ready_in": "Bereit in",
    "ending": "Wird beendet",
    "notification_enabled_title": "Benachrichtigungen aktiviert",
    "notification_enabled_text": "Wir werden Sie benachrichtigen, sobald Ihre Sitzung bereit ist.",
    "notification_denied_title": "Benachrichtigungen konnten nicht aktiviert werden",
    "notification_denied_text": "Es scheint, als würde Ihr Browser das Versenden von Benachrichtigungen verhindern. Bitte prüfen Sie die Einstellungen ihres Browsers!",
    "skip": "Überspringen",
    "update": "Installieren",
    "debug": {
      "id": "Sitzungs-ID",
      "server_ip": "IP-Addresse",
      "latency": "Latenz",
      "enable_debug": "Debug modus aktivieren",
      "enable_debug_tooltip": "Öffnet VNC und RDP ports auf der VM",
      "debug_enable_tooltip": "Debug modus bereits aktiv",
      "duration": "Sitzungsdauer",
      "app_version_api_id": "Versions-ID",
      "app_api_id": "Anwendungs-ID",
      "vm_image": "VM Abbild",
      "header": "Sitzungsinformationen",
      "streaming_server": "Streaming-Server",
      "xr_encryption_enabled": "End-to-End verschlüsselt",
      "streaming_protocols": "Streaming -Protokolle",
      "xr_device": "Endgerät",
      "xr_gateway_used": "über XR Gateway"
    },
    "preparing": "Sitzung wird vorbereitet",
    "notified_when_ready": "Wir werden Sie benachrichtigen, sobald die Vorbereitungen abgeschlossen sind.",
    "enable_notifications_to_be_notified": "Um benachrichtigt zu werden, sobald die Vorbereitungen abgeschlossen sind, <2>klicken Sie bitte hier</2>",
    "taking_longer_than_expected": "Stream wird jeden Moment gestartet.",
    "calculating_wait_time": "Schätzung der Wartezeit...",
    "rate_dialog": {
      "title": "Wie zufrieden waren Sie mit der Qualität dieser Sitzung?",
      "cancel": "Schließen",
      "rate_action": "Senden",
      "placeholder": "Mehr Informationen"
    },
    "switch_organization": "Zu {{organizationName}} wechseln",
    "switch_organization_info": "Um diese Sitzung anzusehen, wechseln Sie bitte zur Organisation {{organizationName}} oder beenden Sie die Sitzung, um eine neue zu starten.",
    "application": "Anwendungsinformationen"
  },
  "spectator": {
    "actions": {
      "copy": "Text kopieren",
      "paste": "Text einfügen"
    },
    "connection": {
      "new": "Bitte erlauben sie den Zugriff auf das Mikrofon",
      "establishing": "Erstelle Verbindung",
      "connecting": "Verbinde",
      "connected": "Verbunden. Warte auf Inhalt...",
      "disconnected": "Verbindung getrennt",
      "closed": "Verbindung geschlossen",
      "no_frames": "Videostream noch nicht gestartet",
      "no_frames_hint": "Manchmal benötigt eine Anwendung länger, um den Videostream zu starten. \nEs kann sich auch um ein Verbindungsproblem handlen. Um Hilfe zu Verbindungsproblemen zu erhalten, klicken sie hier: "
    },
    "microphone": {
      "failed": "Mikrofon nicht aktiv",
      "unmuting-failed": "Mikrofon konnte nicht aktiviert werden. Bitte prüfen Sie, ob der Zugriff auf ihr Mikrofon im Browser erlaubt wurde."
    },
    "clipboard": {
      "error": {
        "missing-permission-title": "Auf die Zwischenablage konnte nicht zugegriffen werden",
        "missing-permission-description": "Überprüfen Sie die Berechtigungs Einstellungen im Browser und erlauben Sie den Zugriff auf die Zwischenablage."
      }
    },
    "fullscreen": {
      "turn-to-enable-title": "Drehen sie ihr Gerät",
      "turn-to-enable-description": "Um den Vollbildmodus zu aktivieren, drehen sie bitte ihr Gerät (Querformat).",
      "turn-to-disable-title": "Drehen sie ihr Gerät",
      "turn-to-disable-description": "Um den Vollbildmodus zu verlassen, drehen sie bitte ihr Gerät (Hochformat)."
    },
    "audio": {
      "blocked_by_browser_policy": "Die Richtlinie Ihres Browsers verhindert derzeit die Wiedergabe von Audio, bis Sie die Stummschaltung manuell aufheben, indem Sie unten klicken.",
      "unmute": "Stummschaltung aufheben",
      "ignore": "Ignorieren"
    },
    "remoteUrls": {
      "text": "Die Anwendung hat versucht, die folgende URL remote zu öffnen. \nKlicken Sie stattdessen unten, um es in Ihrem Browser zu öffnen:",
      "title": "Remote-URLs"
    },
    "windows": {
      "switch": "Fenster wechseln"
    }
  },
  "legal": {
    "title": "Rechtliches / Impressum",
    "managing_director": "Geschäftsführer",
    "contact": "Kontakt",
    "other": "Weitere rechtliche Informationen",
    "vat": "USt-IdNr"
  },
  "privacy": {
    "title": "Datenschutzbestimmungen"
  },
  "terms": {
    "title": "Nutzungsbedingungen"
  },
  "list": {
    "empty": {
      "title": "Oh nein!",
      "description": "Es scheint, als gäbe es (noch) keine Anwendungen auf die Sie Zugriff haben!",
      "action_description": "Es gibt noch keine Anwendungen. Laden Sie Ihre erste Anwendung im Kontrollcenter hoch.",
      "action_description_no_permission": "Keine Anwendungen verfügbar. Bitte wenden Sie sich an einen Administrator, um die nötigen Berechtigungen zu erhalten.",
      "action_label": "Anwendungen verwalten"
    },
    "view": {
      "categories": "Kategorien",
      "all": "Alle Apps"
    },
    "no_results": "Keine Anwendungen entsprechen den gewählten Filtern."
  },
  "device": {
    "came_online_title": "Endgerät verbunden",
    "came_online": "Ihr Endgerät \"{{name}}\" ist jetzt verfügbar.",
    "went_offline_title": "Endgerät offline",
    "went_offline": "Ihr Endgerät \"{{name}}\" ist nicht mehr verfügbar."
  },
  "menu": {
    "control_panel": "Control Panel",
    "admin_panel": "Admin Panel"
  },
  "preferences": {
    "dialog": {
      "title": "Vorlieben",
      "explanation": "Hier können Sie die Präferenzen für Streaming anpassen um die - für ihre Region und ihren Anwendungsfall - optimalen Einstellungen zu finden. Wir empfehlen, diese Einstellungen nicht anzupassen, sofern nicht unbedingt notwendig. Bitte nutzen Sie den Server-Standort Assistenten um ihren optimalen Server-Standort zu finden.",
      "preferredCloudProvider": "Aktive Cloud-Anbieter",
      "savedTitle": "Änderungen gespeichert",
      "saved": "Wir haben ihre neuen Präferenzen gespeichert",
      "errorTitle": "Fehler",
      "error": "Änderungen konnten nicht gespeichert werden.",
      "regions": "Verfügbare Standorte",
      "automaticModeLabel": "Zum Automatischen Modus wechseln",
      "manualModeLabel": "Zum Manuellen Modus wechseln",
      "vm_sizes": "Größen",
      "savedSecurity": "Wir haben Ihre Sicherheitseinstellungen erfolgreich aktualisiert.",
      "savedStreamingProtocol": "Wir haben Ihre Streaming-Einstellungen erfolgreich aktualisiert."
    },
    "map": {
      "setaspreferred": "Bevorzugen",
      "ispreferred": "Bevorzugt",
      "distance": "Distanz (ca.)",
      "latency": "Latenz",
      "region": "Region",
      "disabled": "Nicht nutzbar"
    },
    "preferred_region_unavailable": "Region nicht verfügbar",
    "preferred_region_unavailable_details": "Ihre gewünschte Region „{{ preferredRegion }}“ ist derzeit nicht verfügbar oder kann nicht für Streaming verwendet werden. Bitte wählen Sie eine andere Region um Streaming zu nutzen oder wechseln sie in den automatischen Modus.",
    "preferred_region_unsupported": "Region nicht unterstützt",
    "preferred_region_unsupported_details": "Unsere Systeme haben festgestellt, dass die gewünschte Region „{{ preferredRegion }}“ kein Streaming der ausgewählten Anwendung unterstützt. Wir empfehlen daher, eine andere Region auszuwählen, um Streaming zu verwenden, oder den automatischen Modus zu aktivieren. Wenn Sie sich sicher sind, dass die gewünschte Region Streaming unterstützt, können Sie diese Warnung ignorieren und auf das Risiko einer eingeschränkten Erfahrung hin fortfahren.",
    "region_preference": "Server-Standort",
    "security_preferences": "Sicherheit",
    "security": {
      "encrypt_vr_stream": "Verschlüsseln Sie VR-Streams",
      "encrypt_vr_stream_help_text_disabled": "Deaktivieren der Verschlüsselung kann - auf Kosten der Sicherheit - zu einer geringeren Latenz und einem besseren Benutzererlebnis führen.",
      "encrypt_vr_stream_help_text_enabled": "Verschlüsselung für VR-Streaming erhöht die Sicherheit und wird dringend empfohlen.",
      "debug_mode": "Debug Modus Aktivieren",
      "debug_mode_help_text_disabled": "Der Debug-Modus ist auf VM standardmäßig deaktiviert",
      "debug_mode_help_text_enabled": "Der Debug-Modus ist auf der VM standardmäßig aktiviert",
      "policies_deny_encrypt_vr_stream_change": "Die Richtlinien Ihrer Organisation verhindern, dass Sie diese Einstellung ändern. \nBitte wenden Sie sich an Ihren Administrator."
    },
    "streaming": {
      "custom_vm_image": "(Benutzerdefiniert) VM-Image",
      "custom_vm_image_help_text": "Wenn Sie oben ein benutzerdefiniertes Abbild einer virtuellen Maschine (VM) angeben, können Sie eine Anwendung auf einer Maschine mit unterschiedlichen Voreinstellungen oder Funktionen ausführen. \nMögliche Werte für diese Einstellung hängen von der Bereitstellung ab. \nBeachten Sie, dass nicht alle VM-Abbilder in allen Streaming-Regionen verfügbar sind.",
      "vm_id": "Virtual Machine ID",
      "vm_id_help_text": "Angabe einer VM-ID, um sicherzustellen, dass aufeinanderfolgende Sitzungen auf derselben VM ausgeführt werden"
    },
    "protocols": {
      "use_xr_gateway": "Gateway für XR-Streaming verwenden",
      "use_xr_gateway_help_text_disabled": "An ausgewählten Stellen können Sie ein zentrales Gateway verwenden, um eine Verbindung zu XR -Streams herzustellen. \nDies fügt minimaler Overhead (Latenz) hinzu.",
      "use_xr_gateway_help_encryption_required": "Um ein Gateway für das XR -Streaming zu verwenden, muss die Verschlüsselung aktiviert werden."
    },
    "advanced": "Fortschrittlich"
  },
  "invitation": {
    "accepted": {
      "title": "Willkommen im {{name}}!",
      "description": "Sie haben die Einladung akzeptiert und können nun die verfügbaren Inhalte entdecken und nutzen."
    }
  },
  "vmUpgradeNotification": {
    "title": "Systemleistung aufgerüstet",
    "description": "Ihre Sitzung wurde auf einem leistungsstärkeren Streaming-Server gestartet, um die Startzeit zu verkürzen."
  },
  "or": "oder",
  "featureFlags": {
    "title": "Feature-Flags",
    "description": "Feature-Flags ermöglichen das Aktivieren/Deaktivieren bestimmter (experimenteller!) Funktionen. \nDie hier aktivierten Funktionen gelten nur für Ihr Benutzerkonto und nur innerhalb der aktuell aktiven Organisation."
  },
  "server_location_wizard": {
    "region": "Region",
    "cloud_provider": "Cloud Anbieter",
    "distance": "Distanz (ca.)",
    "latency": "Latenz",
    "hide_details": "Details verbergen",
    "show_details": "Details anzeigen",
    "restart_test": "Erneut starten",
    "title": "Assistent für Server-Standort",
    "test_description": "Um das Streaming-Erlebnis zu optimieren, testen wir die verfügbaren Streaming Server, um den idealen Standort für Sie zu finden.",
    "network": "Netzwerk",
    "your_pc": "Dieser PC",
    "cloud_rendering_infrastructure": "Streaming Server",
    "success_header": "Optimaler Server-Standort gefunden!",
    "keep_page_open_warning": "Um optimale Ergebnisse zu erzielen, stoppen Sie alle potenziell laufenden Downloads, lassen Sie diese Seite geöffnet und wechseln Sie nicht zu einer anderen Registerkarte, während die automatischen Prüfungen ausgeführt werden.",
    "close": "Assistent schließen",
    "latency_table_description": "Unten sehen Sie eine Liste aller verfügbaren Render Standorte, von denen Sie eine Anwendung streamen können. \nSie können bestimmte Standorte manuell (neu) evaluieren lassen, um ihre Leistung für das Streaming zu bestimmen, oder manuell einen Standort auswählen, um die automatische Auswahl zu überschreiben.",
    "latency_table_select_all": "Alles auswählen (auf dieser Seite)",
    "check_selected_regions": "Ausgewählte Standorte prüfen",
    "check_selected_regions_button_disabled_hint": "Bitte wählen Sie zunächst einige Standorte zur Überprüfung aus",
    "cancel": "Stornieren",
    "proceed": "Fortfahren",
    "heading": "Server-Standort Optimierung",
    "prevent_navigation_title": "Abbrechen?",
    "abort_dialog_body": "Latenzprüfungen werden noch ausgeführt - sind Sie sicher, dass Sie gehen möchten?",
    "prevent_navigation_abort": "Abbrechen",
    "prevent_navigation_stay": "Weitermachen",
    "latency_test_running": "Für die besten Ergebnisse verlassen Sie diese Seite bitte nicht, während die Überprüfungen im Gange sind."
  },
  "createRenderMachine": {
    "toast": {
      "title": "Streaming-Server angefragt",
      "description": "Der Streaming-Server wurde angefordert. Es kann einige Zeit dauern, bis der Server einsatzbereit ist."
    },
    "toast_error": {
      "title": "Streaming-Server konnte nicht erstellt werden",
      "description": "Der Streaming-Server konnte nicht erstellt werden. Bitte versuchen Sie es später erneut."
    }
  },
  "destroyRenderMachine": {
    "toast": {
      "title": "Server erfolgreich zur Entfernung angefordert",
      "description": "Server wird entfernt"
    },
    "toast_error": {
      "title": "Ein Fehler ist beim Entfernen des Servers aufgetreten",
      "description": "Der Server konnte nicht entfernt werden. Bitte versuchen Sie es später erneut."
    }
  },
  "streaming_server": {
    "terminate_dialog": {
      "title": "Server entfernen",
      "are_you_sure": "Sind Sie sicher, dass Sie diesen Server entfernen möchten?",
      "cancel": "Abbrechen",
      "confirm": "Bestätigen"
    },
    "stream_button": {
      "destroy": "Abschalten",
      "cancel": "Streaming-Server abbrechen",
      "create_button": "Streaming-Server erstellen",
      "expires_in_time": "Läuft ab in {{time}} h",
      "expired": "Abgelaufen"
    },
    "status": {
      "provisioning_infrastructure": "Streaming-Server wird bereitgestellt",
      "infrastructure_ready": "Streaming-Server-Ressourcen bereit",
      "booting_server": "Streaming-Server wird gestartet",
      "configuring_network": "Servernetzwerk wird konfiguriert",
      "installing_apps": "Anwendungen werden installiert",
      "finalizing_setup": "Servereinrichtung wird abgeschlossen",
      "ready": "Bereit",
      "preparing": "Streaming-Server wird vorbereitet",
      "errored": "Streaming-Server fehlgeschlagen",
      "creating": "Erstellen",
      "booting": "Starten",
      "installing": "Installieren",
      "default": "Streaming"
    },
    "status_short": {
      "provisioning_infrastructure": "Bereitstellen",
      "infrastructure_ready": "Vorbereiten",
      "booting_server": "Starten",
      "configuring_network": "Konfigurieren",
      "installing_apps": "Installieren",
      "finalizing_setup": "Abschließen",
      "ready": "Bereit",
      "preparing": "Vorbereiten",
      "errored": "Fehlgeschlagen"
    },
    "intent_status": {
      "selecting_region": "Beste Region wird ausgewählt…"
    },
    "error_dialog": {
      "title": "Streaming-Server Fehler",
      "RetriesExhausted": "Wir konnten Ihren Streaming-Server nicht einrichten. Alle verfügbaren Regionen wurden versucht, aber keine konnte einen Server erfolgreich bereitstellen.",
      "NoRegionFound": "Es konnte keine geeignete Region gefunden werden, um einen Streaming-Server bereitzustellen.",
      "suggestion": "Dies ist normalerweise ein vorübergehendes Problem. Bitte versuchen Sie es in einigen Minuten erneut oder wählen Sie manuell eine andere Region in Ihren Einstellungen.",
      "additional_info": "Für den Support geben Sie bitte folgende Intent-ID an:",
      "report": "Support kontaktieren",
      "dismiss": "Schließen",
      "report_summary": "Streaming-Server Fehler für Intent {{ intentId }}",
      "report_description": "Der Streaming-Server konnte nicht bereitgestellt werden.\\nRegion: {{ region }}\\nGröße: {{ size }}",
      "copy": "Kopieren",
      "copied": "Kopiert"
    },
    "extend": {
      "add_1_hour": "Um 1 Stunde verlängern",
      "add_2_hours": "Um 2 Stunden verlängern",
      "add_3_hours": "Um 3 Stunden verlängern",
      "success": "Verlängerung erfolgreich",
      "success_description": "Server um {{hours}} Stunde(n) verlängert",
      "error": "Verlängerung fehlgeschlagen",
      "error_description": "Die Ablaufzeit des Servers konnte nicht verlängert werden"
    },
    "ready_notification": {
      "title": "Streaming-Server bereit",
      "message": "Ihr Streaming-Server ist jetzt bereit. Die Anwendung wird automatisch gestartet.",
      "auto_proceed": "Start in {{seconds}} Sekunden...",
      "cancel": "Abbrechen",
      "proceed": "Streaming starten"
    },
    "region": {
      "select": "Region auswählen",
      "manual": "(Manuell)",
      "automatic": "Automatische Auswahl",
      "automatic_description": "Automatisch die beste Region basierend auf Latenz auswählen",
      "search": "Suche",
      "search_placeholder": "Regionen suchen...",
      "filters": "Filter",
      "clear_filters": "Zurücksetzen",
      "no_regions_found": "Keine Regionen gefunden",
      "cloud_providers": "Cloud-Anbieter"
    },
    "dialog": {
      "title": "Streaming-Server starten",
      "sub_heading": "Wählen Sie die Anwendungen aus, die Sie auf Ihrem Streaming-Server vorinstallieren möchten. Durch die Vorinstallation werden die Ladezeiten der Sitzungen verkürzt.",
      "selected_apps": "Ausgewählte Anwendungen",
      "available_apps": "Verfügbare Anwendungen",
      "no_apps_selected": "Noch keine Anwendungen ausgewählt. Wählen Sie unten eine oder mehrere Anwendungen aus.",
      "search_placeholder": "Nach Anwendungen suchen",
      "server_configuration_section": "Server-Konfiguration",
      "server_recommendation": "Basierend auf Ihrer Auswahl empfehlen wir folgende Konfiguration:",
      "change": "Ändern",
      "cancel": "Abbrechen",
      "selectNumberOfApps": "Wählen Sie Anwendungen aus, die vorinstalliert werden sollen. Vorinstallierte Anwendungen reduzieren die Ladezeit einer Sitzung. Basierend auf den ausgewählten Anwendungen und ihrer Verbindungsqualität haben wir festgestellt, dass ",
      "bestRegion": " der optimale Serverstandort ist; mit der Server-Konfiguration ",
      "youCan": "Sie können",
      "overwriteRegion": "die Regionsauswahl manuell überschreiben",
      "additionallyYouCan": "Sie können auch",
      "overwriteMachineSize": "die Server-Konfiguration manuell überschreiben",
      "hideAndResetManualRegionSelection": "Standort-Auswahl ausblenden und zurücksetzen.",
      "hideAndResetManualVmSizeSelection": "Server-Leistungsauswahl ausblenden und zurücksetzen.",
      "createRenderMachine": "Streaming-Server erstellen",
      "clearAllPreInstalledApps": "Auswahl zurücksetzen",
      "cannot_select_tooltip": "Maximale Anzahl vorinstallierter Anwendungen erreicht",
      "noValidRegionAvailable": "Wir konnten keine Region finden, in der Sie Ihren Streaming-Server mit den gewünschten Einstellungen und/oder Anwendungen erstellen können. Bitte ändern Sie Ihre Einstellungen oder wenden Sie sich an einen Administrator.",
      "overrideRegion": "Region überschreiben",
      "overrideVmSize": "Leistungsstufe überschreiben",
      "resetRegionToDefault": "Auf empfohlene Region zurücksetzen",
      "resetVmSizeToDefault": "Auf empfohlene Leistungsstufe zurücksetzen"
    },
    "status_button": {
      "disable_button": "Klicken, um diesen Server nicht mehr zu verwenden",
      "enable_button": "Klicken, um diesen Server zu verwenden",
      "destroy_tooltip": "Zerstören Sie diesen Server?",
      "active": "Aktiv",
      "select": "Auswählen"
    },
    "conflict": {
      "title": "Kompatibilitätsproblem mit Streaming-Server",
      "xr_gateway_not_supported": "Ihr bestehender Streaming-Server in {{region}} unterstützt kein XR Gateway, was derzeit durch Ihre Einstellungen oder Organisationsrichtlinien erforderlich ist.",
      "explanation": "Um mit dem Start der Anwendung fortzufahren, können Sie eine der folgenden Optionen wählen:",
      "option_1_title": "Neuen Streaming-Server erstellen",
      "option_1_description": "Einen neuen Server mit den erforderlichen Spezifikationen erstellen.",
      "option_2_title": "Einstellungen ändern",
      "option_2_description_xr": "XR Gateway-Anforderung deaktivieren.",
      "change_preferences_button": "Einstellungen ändern",
      "create_new_button": "Neuen Server erstellen",
      "vm_size_too_small": "Ihr vorhandener Streaming-Server in der Region {{region}} ({{currentSize}}) erfüllt nicht die Mindestgröße ({{requiredSize}}) für diese Anwendung.",
      "vm_size_explanation": "Die Leistung ihres existierenden Streaming-Server ist unzureichend für die angeforderte Anwendung. Sie müssen einen neuen Streaming-Server mit ausreichenden Ressourcen erstellen, um fortzufahren.",
      "option_1_additional_info": "Der Streaming-Server wird in {{region}} erstellt.",
      "create_new_in_other_region_button": "Neuen Server erstellen ({{region}})",
      "disable_xr_gateway_button": "Deaktivieren Sie das XR-Gateway"
    }
  },
  "authorization_error": "Es ist ein unerwarteter Fehler aufgetreten",
  "streamer": {
    "dcv": {
      "preferences": {
        "mode_responsiveness": "Beste Reaktionsfähigkeit",
        "mode_quality": "Beste Qualität",
        "mode_responsiveness_help": "Bietet das flüssigste Erlebnis.",
        "mode_quality_help": "Bietet beste Bildqualität.",
        "high_color_accuracy": "Hohe Farbgenauigkeit (YUV 4.4.4)",
        "high_color_accuracy_help": "Die Streaming-Leistung könnte beeinträchtigt sein.",
        "streaming_mode": "Streaming-Modus",
        "high_color_accuracy_disabled": "Deaktiviert",
        "high_color_accuracy_enabled": "Ermöglicht",
        "title": "DCV-Einstellungen",
        "change": "DCV-Einstellungen verwalten"
      },
      "high_color_accuracy_unsupported": "Eine hohe Farbgenauigkeit wird nicht unterstützt",
      "resolution_capped_title": "Eingeschränkte Remote-Auflösung",
      "resolution_capped_description": "Diese Maschine kann ihre Auflösung nicht an die Fenstergröße anpassen. Dadurch können schwarze Ränder um den Stream entstehen. Eine erneute Verbindung kann eine passende Maschine zuweisen.",
      "stats": {
        "show": "Streaming-Statistiken anzeigen",
        "hide": "Streaming-Statistiken ausblenden",
        "fps": "FPS",
        "latency": "Latenz",
        "traffic": "Datenverkehr",
        "peak": "Spitzenwert"
      }
    }
  },
  "user": {
    "preferences": "Vorlieben",
    "scheduled_sessions": "Geplante Sitzungen",
    "expert_mode": "Expertenmodus",
    "expert_mode_description": "Aktivieren Sie zusätzliche Funktionen freischalten. \nNur für Expertenbenutzer empfohlen.",
    "notifications_badge": "{{count}} Elemente erfordern Aufmerksamkeit"
  },
  "installable_app": {
    "queued": "Warte auf Installation von {{appName}}",
    "installing": "{{appName}} wird installiert ..."
  },
  "organization": {
    "error_loading": "Fehler beim Abrufen der Organisationsinformationen"
  },
  "branding": {
    "loading": "Branding für Organisation wird geladen ...",
    "error_loading": "Branding konnte nicht geladen werden"
  },
  "generic": {
    "not_available_short": "n.v."
  },
  "schedule": {
    "modal": {
      "title": "Sitzung planen",
      "edit_title": "Sitzung bearbeiten",
      "application": "Anwendung",
      "name": "Name der Veranstaltung",
      "name_placeholder": "Geben Sie einen Namen für diese Sitzung ein",
      "start_time": "Startzeit",
      "end_time": "Endzeit",
      "end_time_error": "Die Endzeit muss nach der Startzeit liegen",
      "max_duration_error": "Die Veranstaltungsdauer darf {{maxHours}} Stunden nicht überschreiten",
      "participants": "Teilnehmer",
      "select_user": "Benutzer zum Hinzufügen auswählen",
      "search_user": "Nach Benutzer suchen...",
      "no_users_found": "Keine Benutzer gefunden",
      "add_participant": "Teilnehmer hinzufügen",
      "remove_participant": "Teilnehmer entfernen",
      "no_participants": "Noch keine Teilnehmer hinzugefügt",
      "requires_cloud": "Cloud-Infrastruktur",
      "cancel": "Abbrechen",
      "schedule": "Planen",
      "update": "Sitzung aktualisieren",
      "done": "Fertig",
      "success_title": "Sitzung geplant!",
      "success_description": "Ihre Sitzung wurde erstellt. Teilen Sie den untenstehenden Link mit den Teilnehmern, damit sie ihre Teilnahme bestätigen können.",
      "rsvp_link": "RSVP-Link",
      "copy_link": "Link kopieren",
      "rsvp_link_description": "Teilen Sie diesen Link mit den Teilnehmern, um ihre Teilnahme zu bestätigen",
      "no_stream_access": "Benutzer hat keinen Stream-Zugriff. Klicken Sie hier, um Berechtigungen zu verwalten."
    },
    "list": {
      "title": "Geplante Sitzungen",
      "empty": "Noch keine geplanten Sitzungen",
      "column_name": "Name",
      "column_time": "Zeit",
      "column_participants": "Teilnehmer",
      "column_apps": "Anwendungen",
      "apps": "Apps",
      "past": "Vergangen",
      "ongoing": "Laufend",
      "delete": "Löschen",
      "rsvp": "RSVP",
      "edit": "Bearbeiten",
      "open_rsvp": "RSVP-Seite öffnen",
      "add_to_calendar": "Zum Kalender hinzufügen",
      "copy_id": "ID kopieren",
      "copy_id_success": "ID in Zwischenablage kopiert",
      "delete_title": "Geplante Sitzung löschen",
      "delete_confirm": "Sind Sie sicher, dass Sie \"{{name}}\" löschen möchten?",
      "cancel": "Abbrechen",
      "filter": {
        "title": "Time",
        "show_past": "Vergangene Events anzeigen"
      },
      "infrastructure": {
        "title": "Infrastruktur-Status",
        "ready": "Bereit",
        "provisioning": "Wird bereitgestellt...",
        "pending": "Ausstehend",
        "not_accepted": "Nicht akzeptiert",
        "not_required": "Nicht erforderlich",
        "error": "Fehler",
        "no_permission": "Keine Berechtigung",
        "no_permission_hint": "Sie haben keine Berechtigung, den Infrastruktur-Status anderer Teilnehmer einzusehen."
      },
      "rsvp_status": {
        "title": "RSVP-Status",
        "accepted": "Akzeptiert",
        "declined": "Abgelehnt",
        "pending": "Ausstehend"
      }
    },
    "toast": {
      "created": {
        "title": "Sitzung geplant",
        "description": "Ihre Sitzung wurde erfolgreich geplant"
      },
      "updated": {
        "title": "Sitzung aktualisiert",
        "description": "Ihre Sitzung wurde erfolgreich aktualisiert"
      },
      "deleted": {
        "title": "Sitzung gelöscht",
        "description": "Ihre geplante Sitzung wurde gelöscht"
      },
      "error": {
        "title": "Fehler",
        "description": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
      }
    },
    "rsvp": {
      "invitation": "Sie wurden zu dieser Sitzung eingeladen",
      "add_to_calendar": "Zum Kalender hinzufügen",
      "participants": "Teilnehmer",
      "you": "Sie",
      "accept": "Annehmen",
      "decline": "Ablehnen",
      "event_past": "Diese Veranstaltung ist bereits beendet",
      "event_deleted": "Diese Veranstaltung wurde gelöscht",
      "already_accepted": "Sie haben diese Einladung bereits angenommen",
      "already_declined": "Sie haben diese Einladung abgelehnt",
      "latency_required": "Standortprüfung erforderlich",
      "latency_description": "Um die beste Erfahrung zu gewährleisten, müssen wir Ihre Verbindung zu unseren Servern überprüfen.",
      "run_latency_test": "Verbindungstest durchführen",
      "latency_running": "Verbindungsqualität wird überprüft...",
      "error": {
        "title": "Fehler",
        "not_found": "Die Veranstaltung konnte nicht gefunden werden",
        "not_participant": "Sie sind kein Teilnehmer dieser Veranstaltung"
      },
      "toast": {
        "success": {
          "title": "Antwort gespeichert",
          "description": "Ihre Antwort wurde erfolgreich gespeichert"
        }
      }
    }
  },
  "latency_checks": {
    "running_button": "Bester Standort wird gesucht"
  },
  "n/a": "n.v."
}
